import React, {Component} from 'react';
import media from '../MediaQueries.js';
import styled from 'styled-components';

import { Collapse, Navbar, NavbarToggler, NavbarBrand, Nav, NavItem,
        NavLink, Container, Row, Col, Jumbotron, Button } from 'reactstrap';
import { Link } from 'react-router-dom'
import visitUsBG from '../media/visituspagebackground.jpg'


const VisitUsSection = (props) => {

	return (
	  <FluidContainer fluid>
	    <InternalContainer>
	      	<h1>Visit Us</h1>
			
			<VisitUsPic src={require("../media/holiday_Hero20221216.jpg")}></VisitUsPic> {/* <VisitUsPic src={require("../media/visituspic.jpg")}></VisitUsPic> */}
			<p>If you are planning a vacation to the North Central Pennsylvania area, we
			   would be happy to schedule a tour for you. Plus, we have product price discounts in person!</p>
		  	<Link to="/Tour">
			  	<ScheduleButton>
					<p>Schedule a Tour!</p>
				</ScheduleButton>
		  	</Link>
		  
	    </InternalContainer>
	  </FluidContainer>
	); 
};

const VisitUsPic = styled.img`
	margin: 0 0 15px 0;
	width: 100%;
	height: auto;
`;	

const FluidContainer = styled(Container)`
	padding: 20px 0 20px 0!important;
	background-image: url(${visitUsBG}); 
`;
const InternalContainer = styled(Container)`
	text-align: center;
	h1 { 
		margin: 0 0 20px 0;
		color: white;
	}
	p { color: white; }
`;

const ScheduleButton = styled(Button)`
  cursor: pointer;
  display: block;
  border: 0px!important;
  color: white!important;
  font-weight: bold!important;
  background-color: #800000!important;
  width: 250px;
  ${media.sm` width: 290px; `}
  height: 40px;
  line-height: 20px!important;
  transition: all 0.5s;
  margin: 0!important;

  p {
    cursor: pointer;
    display: inline;
    position: relative;
    transition: 0.5s;
  }

  p:after {
    content: '\00bb';
    position: absolute;
    opacity: 0;
    right: -20px;
    transition: 0s;
  }

  :hover p { padding-right: 25px; }
  :hover p:after { opacity: 1; right: 0; }
  :active p:after { opacity: 0; }
  :active { box-shadow: 0 5px #666; transform: translateY(6px); }
  

`;

/*
const ListViewContainer = styled(({ listSelected, ...rest }) => <Container {...rest} />)`
  display: ${a => a.listSelected ? "block" : "none"};
  ${media.sm` background-image: url(${smHeroImage}); height: 362px; `}
`;
*/

export default VisitUsSection;


// WEBPACK FOOTER //
// ./src/components/VisitUsSection.js